/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */

const data = {
    arrowSignImage: 'https://cdn1.1800flowers.com/wcsstore/Flowers/images/2015/sympathy/landing/sym-view-all-arrow.png',
    Food: [{
        title: 'Kosher Gourmet Food & Baskets',
        url: '/kosher-gift-baskets-food-gift-400176543',
        products: [
            {
                product_url: '/with-remembrance-kosher-fruit-sweets-basket-149690?categoryId=400176543',
                name: 'With Remembrance Kosher Fruit & Sweets Basket',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Baskets/images/catalog/149690gc.jpg',
                    altText: 'With Remembrance Kosher Fruit & Sweets Basket',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '99.99',
                    higher_price: '119.99',

                },
                deliveryOption: 'Shipped in a Gift Box',

            },
            {
                product_url: '/Wishing-You-Peace-Sympathy-Fruit-Basket?categoryId=400176543',
                name: 'Wishing You Peace Sympathy Fruit Basket',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Baskets/images/catalog/96275c.jpg',
                    altText: ' Wishing You Peace Sympathy Fruit Basket',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '69.99',
                    higher_price: '99.99',

                },
                deliveryOption: 'Shipped in a Gift Box',

            },
            {
                product_url: '/share-your-loss-kosher-gourmet-gift-basket-149674?categoryId=400176543',
                name: 'We Share Your Loss Kosher Gourmet Gift Basket ',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Baskets/images/catalog/149674c.jpg',
                    altText: 'We Share Your Loss Kosher Gourmet Gift Basket ',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '',
                    higher_price: '119.99',

                },
                deliveryOption: 'Shipped in a Gift Box',

            },
            {
                product_url: '/spirit-of-peace-fruit-nut-crate-149653?categoryId=400176543',
                name: 'A Spirit of Peace Fruit & Nut Crate',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Baskets/images/catalog/149653c.jpg',
                    altText: 'A Spirit of Peace Fruit & Nut Crate ',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '39.99',
                    higher_price: '',

                },
                deliveryOption: 'Shipped in a Gift Box',

            },
        ],
    },
    {
        title: 'Non-Kosher Gourmet Food & Baskets',
        url: '/non-kosher-gift-baskets-food-gift-400176544',
        products: [
            {
                product_url: '/with-sympathy-fruit-sweets-gift-basket-149573?categoryId=400176544',
                name: 'With Sympathy Fruit & Sweets Gift Basket',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Baskets/images/catalog/149573gc.jpg',
                    altText: 'With Sympathy Fruit & Sweets Gift Basket',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '89.99',
                    higher_price: '139.99',

                },
                deliveryOption: 'Shipped in a Gift Box',

            },
            {
                product_url: '/with-sympathy-and-support-angel-book-basket-163000?categoryId=400176544',
                name: 'With Sympathy & Support Angel & Book Basket',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Baskets/images/catalog/162564c.jpg',
                    altText: 'With Sympathy & Support Angel & Book Basket',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '59.99',
                    higher_price: '',

                },
                deliveryOption: 'Shipped in a Gift Box',

            },
            {
                product_url: '/Wishing-You-Peace-Sympathy-Fruit-Basket?categoryId=400176544',
                name: 'Wishing You Peace Sympathy Fruit Basket ',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Baskets/images/catalog/96275c.jpg',
                    altText: 'Wishing You Peace Sympathy Fruit Basket',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '69.99',
                    higher_price: '99.99',

                },
                deliveryOption: 'Shipped in a Gift Box',

            },
            {
                product_url: '/Remembering-Your-Loved-One-Sympathy-Gift-Basket?categoryId=400176544',
                name: 'Sympathy Gift Basket Remembering Your Loved One',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Baskets/images/catalog/96155c.jpg',
                    altText: 'Sympathy Gift Basket Remembering Your Loved One',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '',
                    higher_price: '149.99',

                },
                deliveryOption: 'Shipped in a Gift Box',

            },
        ],
    }, {
        title: 'Plants & Memorial Trees',
        url: '/sympathy-plants-400176545',
        products: [
            {
                product_url: '/sympathy-peace-lily-plant-161804?categoryId=400176545',
                name: 'Peace Lily Plant for Sympathy',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/161834lc.jpg',
                    altText: 'Peace Lily Plant for Sympathy',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '44.99',
                    higher_price: '99.99',

                },
                deliveryOption: 'Same-Day Local Florist Delivery',

            },
            {
                product_url: '/dish-garden-with-fresh-cut-flowers-sympathy-4214?categoryId=400176545',
                name: 'Dish Garden With Fresh Cut Flowers For Sympathy ',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/1870l120418c.jpg',
                    altText: 'Dish Garden With Fresh Cut Flowers For Sympathy ',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '59.99',
                    higher_price: '79.99',

                },
                deliveryOption: 'Same-Day Local Florist Delivery',

            },
            {
                product_url: '/grand-gardenia-18569?categoryId=400176545',
                name: 'Grand Gardenia™ Plant for Sympathy',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/18569ac.jpg',
                    altText: 'Grand Gardenia™ Plant for Sympathy',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '34.99',
                    higher_price: '64.99',

                },
                deliveryOption: 'Shipped in a Gift Box',

            },
            {
                product_url: '/classic-sympathy-dish-garden-3999?categoryId=400176545',
                name: 'Classic Dish Garden for Sympathy',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/1890l120418c.jpg',
                    altText: 'Classic Dish Garden for Sympathy',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '54.99',
                    higher_price: '74.99',

                },
                deliveryOption: 'Same-Day Local Florist Delivery',

            },
        ],
    },
    {
        title: 'Remembrance Keepsakes',
        url: '/sympathy-remembrance-400176546',
        products: [
            {
                product_url: '/gifts-sympathy-gold-white-rose-155098?categoryId=400176546',
                name: '24K Gold Rose for Sympathy',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/155098c.jpg',
                    altText: '24K Gold Rose for Sympathy',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '69.99',
                    higher_price: '',

                },
                deliveryOption: 'Shipped in a Gift Box',

            },
            {
                product_url: '/sympathy/in-memory-candle-97343?categoryId=400176546',
                name: 'In Memory of a Life So Beautifully Lived Candle ',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/97343122118c.jpg',
                    altText: 'In Memory of a Life So Beautifully Lived Candle',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '34.99',
                    higher_price: '',

                },
                deliveryOption: 'Shipped in a Gift Box',

            },
            {
                product_url: '/sympathy/kindnotes-97342?categoryId=400176546',
                name: '31 Days of Kind Notes® for Sympathy and Book',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/97342nbkc.jpg',
                    altText: '31 Days of Kind Notes® for Sympathy and Book',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '39.99',
                    higher_price: '49.99',

                },
                deliveryOption: 'Shipped in a Gift Box',

            },
            {
                product_url: '/personalized-remembrance-messenger-bird-139946?categoryId=400176546',
                name: 'Personalized Remembrance Messenger Bird',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/139946c.jpg',
                    altText: 'Personalized Remembrance Messenger Bird',
                    image_name: '',
                    image_snipe: {
                        image_path: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/snipes/personalizethis_c.gif',
                        altText: 'snipecorner',
                    },
                },
                prices: {

                    lower_price: '19.99',
                    higher_price: '',

                },
                deliveryOption: 'Shipped in a Gift Box',
            },
        ],
    },
    ],
    advisors: {
        nameAdvisors: 'Our Sympathy Advisors are here to help',
        serviceList: [
            {
                link: '/the-jewish-funeral-400178494?cm_sp=sci-_-cremation-advisor-_-spot1-jewishfuneral',
                serviceName: 'The Jewish Funeral',
            },
            {
                link: '/Sympathy-Commonly-Asked-Questions-400178485?cm_sp=sci-_-cremation-advisor-_-spot2-faq',
                serviceName: 'Commonly Asked Funeral Flower Questions',
            },
            {
                link: '/Sympathy-Creating-A-Memory-Garden-400178486?cm_sp=sci-_-cremation-advisor-_-spot3-memorygarden',
                serviceName: 'Creating a Memory Garden',
            },
            {
                link: '/sympathy-article-card-message-suggestions-400178489?cm_sp=sci-_-cremation-advisor-_-spot4-card-message',
                serviceName: 'Sympathy Card Message Suggestions ',
            },
            {
                link: '/Sympathy-Comforting-the-Grieving-400178490?cm_sp=sci-_-cremation-advisor-_-spot5-grieving',
                serviceName: 'How to Comfort The Grieving',
            },
            {
                link: '/Sympathy-Grief-in-the-Workplace-400178491?cm_sp=sci-_-cremation-advisor-_-spot6-workplace',
                serviceName: 'Grief in the Workplace',
            },
            {
                link: '/Sympathy-Article-Grief-and-the-Holidays-400178492?cm_sp=sci-_-cremation-advisor-_-spot7-holidays',
                serviceName: 'Grief and the Holidays',
            },
        ],
    },
    callUsUrl: 'https://sc.liveclicker.net/service/getEmbed?client_id=964&widget_id=22922&width=235&height=157&player_custom_id=1&autoplay=false&html5=true&iframe=true&option_iframeDiv=video_22922',
    flowerArrangements: {
        title: 'Flower Arrangements',
        url: '/sympathy-flowers-400176547',
        products: [
            {
                product_url: '/florist-delivered-healing-tears-blue-white-148683?categoryId=400176547',
                name: 'Healing Tears™ Blue & White',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/148683lc.jpg',
                    altText: 'Healing Tears™ Blue & White',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {
                    lower_price: '49.99',
                    higher_price: '69.99',
                },
                deliveryOption: 'Same-Day Local Florist Delivery',

            },
            {
                product_url: '/sympathy/allwhitearrangement-95097?categoryId=400176547',
                name: 'Classic All White Arrangement™  for Sympathy  ',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/95097lc.jpg',
                    altText: 'Classic All White Arrangement™  for Sympathy ',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {
                    lower_price: '69.99',
                    higher_price: '89.99',
                },
                deliveryOption: 'Same-Day Local Florist Delivery',

            },
            {
                product_url: '/sympathy-loving-blooms-lenox-white-163078?categoryId=400176547',
                name: 'Loving Blooms™ Lenox® All White',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/163078lc.jpg',
                    altText: 'Loving Blooms™ Lenox® All White',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '79.99',
                    higher_price: '99.99',

                },
                deliveryOption: 'Same-Day Local Florist Delivery',

            },
            {
                product_url: '/loving-sentiments-bouquet-174291?categoryId=400176547',
                name: 'Loving Sentiments Bouquet',
                image: {
                    image_path: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/167006lc.jpg',
                    altText: 'Loving Sentiments Bouquet',
                    image_name: '',
                    image_snipe: {},
                },
                prices: {

                    lower_price: '49.99',
                    higher_price: '69.99',

                },
                deliveryOption: 'Same-Day Local Florist Delivery',
            },
        ],
    },
    seo: {
        seo_searchable: false,
        page_title: 'Sympathy Kosher Gourmet Food and Flowers | 1-800-FLOWERS.COM',
        keywords: 'Sympathy SCI Jewish-Sympathy-Web-18F',
        meta_description: 'Sympathy SCI Jewish',
        breadcrumb: [{ title: 'Home', href: '/' }],
        location: { pathname: '/sympathy-400174557' },
    },
    title: 'Sympathy Kosher Gourmet Food and Flowers | 1-800-FLOWERS.COM',
    url: '/sympathy-400174557',

};
export default data;
